// extracted by mini-css-extract-plugin
export default {"carousel":"thumbnailsCarousel_carousel__Xwvsg","carousel__content":"thumbnailsCarousel_carousel__content__ErwTt","carousel__slide":"thumbnailsCarousel_carousel__slide__lq-hd"};